import React, { useState } from 'react';
import { contactInfo } from '../mockData';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Textarea } from '../components/ui/textarea';
import { useToast } from '../hooks/use-toast';

const Contacto = () => {
  const { toast } = useToast();
  const [formData, setFormData] = useState({
    nombre: '',
    apellido: '',
    email: '',
    telefono: ''
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    
    console.log('Form submitted:', formData);
    
    toast({
      title: "¡Mensaje enviado!",
      description: "Nos pondremos en contacto contigo pronto.",
      duration: 5000,
    });

    setFormData({
      nombre: '',
      apellido: '',
      email: '',
      telefono: ''
    });
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <div className="min-h-screen">
      {/* Hero Section with gradient */}
      <section className="py-12 bg-gradient-to-r from-notaria-secondary via-notaria-secondary to-notaria-secondary">
        <div className="container mx-auto px-4">
          <div className="text-white">
            <nav className="text-sm mb-4">
              <span>Home</span>
            </nav>
          </div>
        </div>
      </section>

      {/* Contact Cards */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-6xl mx-auto">
            {/* Visitenos */}
            <div className="bg-notaria-primary text-white p-8 rounded-lg">
              <h3 className="text-xl font-bold mb-4">Visítenos:</h3>
              <p className="text-sm leading-relaxed">
                {contactInfo.address}
              </p>
            </div>

            {/* Llamanos */}
            <div className="bg-notaria-primary text-white p-8 rounded-lg">
              <h3 className="text-xl font-bold mb-4">Llámanos</h3>
              <div className="space-y-2 text-sm">
                <p><strong>Teléfonos:</strong> {contactInfo.phones.join(' / ')}</p>
                <p><strong>Whatsapp:</strong> {contactInfo.whatsapp}</p>
              </div>
            </div>

            {/* Email */}
            <div className="bg-notaria-primary text-white p-8 rounded-lg">
              <h3 className="text-xl font-bold mb-4">Envíenos un correo electrónico a:</h3>
              <a href={`mailto:${contactInfo.email}`} className="text-sm hover:underline">
                {contactInfo.email}
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Form Section */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 max-w-6xl mx-auto items-start">
            {/* Left Content */}
            <div>
              <div className="inline-block bg-notaria-secondary text-white px-4 py-2 rounded-md mb-4 text-sm font-semibold">
                Ya nos encontró
              </div>
              <h2 className="text-4xl md:text-5xl font-bold text-notaria-primary mb-6 leading-tight">
                Nuestros expertos siempre listos para trabajar contigo
              </h2>
              <p className="text-gray-700 text-lg mb-6">
                Para cualquier otra consulta, envíe un correo electrónico a{' '}
                <a href={`mailto:${contactInfo.email}`} className="text-notaria-secondary hover:underline">
                  {contactInfo.email}
                </a>
              </p>

              {/* Google Map */}
              <div className="mt-8 rounded-lg overflow-hidden shadow-lg">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3734.296355870786!2d-87.07684492391965!3d20.62889990095876!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8f4e433967a82fcb%3A0x4e3b0e5e8a2e5e5e!2sC.%2042%20Nte%2059-167%2C%20Zazil-ha%2C%2077720%20Playa%20del%20Carmen%2C%20Q.R.%2C%20Mexico!5e0!3m2!1ses!2smx!4v1704847200000!5m2!1ses!2smx"
                  width="100%"
                  height="300"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Ubicación Notaría 90 - C. 42 Nte 59-167, Zazil-ha, Playa del Carmen"
                ></iframe>
              </div>
            </div>

            {/* Contact Form */}
            <div className="bg-notaria-primary text-white p-8 rounded-lg">
              <div className="flex items-center gap-4 mb-6">
                <img
                  src="https://notariapublica90.com/wp-content/uploads/2025/06/logo-light-notaria.png"
                  alt="Notaria 90"
                  className="h-12 object-contain"
                />
                <h3 className="text-2xl font-bold">Programe una consulta</h3>
              </div>
              
              <form onSubmit={handleSubmit} className="space-y-4">
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm mb-2">Nombre</label>
                    <Input
                      type="text"
                      name="nombre"
                      value={formData.nombre}
                      onChange={handleChange}
                      required
                      className="bg-white text-gray-900"
                    />
                  </div>
                  <div>
                    <label className="block text-sm mb-2">Apellido</label>
                    <Input
                      type="text"
                      name="apellido"
                      value={formData.apellido}
                      onChange={handleChange}
                      required
                      className="bg-white text-gray-900"
                    />
                  </div>
                </div>

                <div>
                  <label className="block text-sm mb-2">Email</label>
                  <Input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    className="bg-white text-gray-900"
                  />
                </div>

                <div>
                  <label className="block text-sm mb-2">Teléfono</label>
                  <Input
                    type="tel"
                    name="telefono"
                    value={formData.telefono}
                    onChange={handleChange}
                    className="bg-white text-gray-900"
                  />
                </div>

                <Button
                  type="submit"
                  className="w-full bg-white text-notaria-primary hover:bg-gray-100 font-semibold py-3"
                >
                  Enviar
                </Button>
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contacto;